const PREFETCH_THRESHOLD = '1000px';

const ARROW_DIRECTIONS = {
  BACK: 'back',
  NEXT: 'next',
};

export { PREFETCH_THRESHOLD, ARROW_DIRECTIONS };
